import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('number_must_be_over_min_number', (value, [target]) => {
  if (Number(value) < Number(target)) {
    return true
  }
  return i18n.global.t('form.number_must_be_over_min_number')
})
